module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"supplier":"Lieferant","error_email":"Sie sind nicht berechtigt auf das Modul zuzugreifen. Bitte wenden Sie sich an Ihrem Hausadmin. Vielen Dank!"},"en":{"supplier":"Supplier","error_email":"You are not authorized to access the module. Please contact your house admin. Thank you very much!"}}')
  delete Component.options._Ctor
}
